<template>
  <div>
    <LmListV2
      ref='LmListBuilderListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Listbuilders',
      gqlField: 'listbuilderLmListV2',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[ListBuilderESSortEnum]) {
      listbuilderLmListV2(
          titleList: "Listado de Listbuilders"
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/listbuilder/edit/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/listbuilder",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]

          ) {
          count
          searcher
          tableItemsTotal
          titleList
          table {
            items {
              alias,titleList,createdAt,updatedAt,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: [
        'id',
        'alias',
        'titleList',
        'createdAt',
        'updatedAt',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'alias',
        'titleList',
        'createdAt',
        'updatedAt',
        'actions'
      ],
      items: [
        {
          name: 'id'
        },
        {
          name: 'alias'
        },
        {
          name: 'titleList'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'actions'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'alias',
          label: 'Alias',
          sortable: false
        },
        {
          key: 'titleList',
          label: 'Titulo',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
